<template>
<div class="d-md-none" style="margin-bottom:57px;">
  <v-app-bar color="" fixed>
    <v-btn icon>
      <v-icon>fa-blank</v-icon>
    </v-btn>

    <v-spacer></v-spacer>
    <span class="logofont text-center">
      <router-link to="/" class="nolink"><span class="primary--text">Why</span><span class="secondary--text">Buy</span></router-link>
    </span>
    <v-spacer></v-spacer>
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
  </v-app-bar>
  <v-navigation-drawer temporary clipped app right v-model="drawer">

    <v-subheader class="secondary white--text font-weight-bold" v-if="$store.getters['account/isAdmin']">Admin Menu</v-subheader>
    <v-list nav v-if="$store.getters['account/isAdmin']">
      <template v-for="(item,i) in adminMenu">
            <v-list-group  :key="'c'+i" v-if="item.children" >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon color="black">{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                            <v-list-item-content  class="font-weight-bold">
                              <v-list-item-title>{{item.title}}</v-list-item-title>
                            </v-list-item-content>
                </template>
      <v-list-item v-for="(child, i) in item.children" :key="i" link class="font-weight-bold" :to="child.to" exact>
        <v-list-item-title v-text="child.title"></v-list-item-title>
        <v-list-item-icon>
          <v-icon color="black">{{ child.icon }}</v-icon>
        </v-list-item-icon>
      </v-list-item>
      </v-list-group>
      <v-list-item link :key="'s'+i" v-else :to="item.to" class="font-weight-bold" exact>
        <v-list-item-icon>
          <v-icon color="black">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </template>

    </v-list>
    <v-subheader class="secondary white--text font-weight-bold">Menu</v-subheader>
    <v-list nav>
      <v-list-item-group active-class="primary--text text--primary-4">


        <v-list-item @click="goSearch" v-if="$store.getters['account/type']==='user'">
          <v-list-item-icon>
            <v-icon color="black">fa-search</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">Search</v-list-item-title>
          </v-list-item-content>

        </v-list-item>


        <v-list-item to="/user/projects" v-if="$store.getters['account/type']==='user'">
          <v-list-item-icon>
            <v-icon color="black">fa-film</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">My Projects</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-list-item to="/user/wallet" v-if="$store.getters['account/type']==='user'">
          <v-list-item-icon>
            <v-icon color="black">fa-wallet</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">Wallet</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/about">
          <v-list-item-icon>
            <img style="height:24px;width:28px" class="mb-1" src="/logo.png" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">About Us</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-4 mb-4"></v-divider>

        <v-list-item to="/access" v-if="$store.getters['account/type']==='visitor'">
          <v-list-item-icon>
            <v-icon color="black">fa-user</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">Sign In / Up</v-list-item-title>
          </v-list-item-content>

        </v-list-item>


        <v-list-item @click="$store.commit('account/logout')" v-if="$store.getters['account/isLoggedIn']">
          <v-list-item-icon>
            <v-icon color="black">fa-walking</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">Sign Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>



  </v-navigation-drawer>
</div>
</template>
<script>
import admin_menu from "@/assets/admin_menu.json"


export default {
  name: "",
  data: () => ({
    drawer: false,
    adminMenu: admin_menu
  }),
  methods: {
    goSearch: function() {
      this.drawer = false;
      if (this.$route.name === 'PublicProjects') {
        this.$store.commit('projects/show_search');
        setTimeout(function() {
          this.$vuetify.goTo("#search", {
            duration: 300,
            offset: 75,
            easing: "easeInOutCubic",
          })
        }.bind(this), 100)

      } else {
        this.$router.push("/#search")
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@font-face {
    font-family: "Arial Rounded MT Bold";
    src: url("/fonts/ArialRoundedMTBold.ttf"), url("/fonts/ArialRoundedMTBold.eot?"), url("/fonts/ArialRoundedMTBold.svg");
}

.logofont {
    font-family: 'Arial Rounded MT Bold', sans-serif;
    font-size: 32px;
    letter-spacing: -2px;
}
</style>
